export const isInPast = (date?: string | Date) => {
  if (!date) return false;


  const today = new Date();
  const dateObj = new Date(date);
  return dateObj < today;
};

export const isInFuture = (date?: string | Date) => {
  if (!date) return false;


  const today = new Date();
  const dateObj = new Date(date);
  return dateObj > today;

};

export const isToday = (date?: string | Date): boolean => {
  if (!date) return false;

  const today = new Date();
  const dateObj = new Date(date);

  return (
    today.getDate() === dateObj.getDate() &&
    today.getMonth() === dateObj.getMonth() &&
    today.getFullYear() === dateObj.getFullYear()
  );
}

export const isInPastOrToday = (date?: string | Date) => {
  if (!date) return false;

  return isInPast(date) || isToday(date);
};

export const isInFutureOrToday = (date?: string | Date) => {
  if (!date) return false;

  return isInFuture(date) || isToday(date);
};

